/**
 * Parses the url query parameters
 * @param search url search string (format: "?param1=value1&param2=value2")
 * @returns map of params and their value
 */
export function parseUrlParams(search: string): Map<string, string> {
  const params = new Map<string, string>();

  if (!search) {
    return params;
  }

  // Ignore the ? character, separate all params and their values
  if (search.charAt(0) === '?') {
    search = search.slice(1);
  }

  // split on & and then = (ex. output. [["param1", "value1"], ["param2", "value2"]])
  const splittedParams = search.split('&').map((param) => param.split('='));

  splittedParams.forEach(([key, value]) => {
    params.set(key, value);
  });

  return params;
}
